import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import fbIcon from './assets/facebook.png';
import { AuthContext } from './auth-context';
import { Button } from './components/Button';
import { getUriParams } from './google-login-button';
import { authorizeWithFacebook, getFacebookEndpoint } from './http';

import './login.scss';
import { logLoginEvent } from './util/logLoginEvent';

export function FBLoginButton() {
  const [endpoint, setEndpoint] = useState<string>('');
  const { setAccessToken } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const query = getUriParams();
    if (query && query.state === 'facebook') {
      authorizeWithFacebook(query.code)
        .then((resp) => {
          if (setAccessToken) {
            setAccessToken(resp.data.access_token);
            logLoginEvent(resp.data.access_token, 'Facebook');

            const queryParams = new URLSearchParams(location.search);
            queryParams.delete('code');
            queryParams.delete('state');
            navigate({ search: queryParams.toString() }, { replace: true });
          }
        })
        .catch((err) => {
          // window.location.replace('/');
        });
    } else {
      getFacebookEndpoint().then((resp) => setEndpoint(resp.data));
    }
    /* eslint-disable-next-line */
  }, [setAccessToken]);

  return (
    <Button
      onClick={() => {
        window.location.replace(endpoint);
      }}
      type="button"
      className="social-login-btn"
    >
      <div className="social-btn-icon-container">
        <img className="social-icon" src={fbIcon} alt={'fb'} />
        <p className="social-btn-text">Facebook</p>
      </div>
    </Button>
  );
}

export default FBLoginButton;
